<template>
    <v-container grid-list-lg>
        <v-layout v-if="painel_vendas"   row wrap card>
            <!--Painel de Vendas-->
            <v-flex md2 mt-2>
                <span class="title">Painel de Vendas</span>
            </v-flex>
            <!--filtro dashboard-->
            <v-flex offset-md8 md2>
                <v-menu content-class="menu-card mt-2 app-content flex"
                        min-width="450px"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        v-model="filtroDash">
                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                        <v-icon color="primary">lnr-funnel</v-icon>
                        <div class="pl-1">Filtrar</div>
                    </v-btn>
                    <v-layout column class="card">
                        <v-layout row wrap>
                            <v-flex mr-3>
                                <v-label>Início</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_ini"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>

                            <v-flex ml-3>
                                <v-label>Fim</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_fim"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout mt-3 justify-center>
                            <v-flex xs4>
                                <v-btn class="btn-default" color="dark" outline @click="limparDash">Limpar</v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <v-btn class="btn-default primary" @click="filtrarDash">Filtrar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-menu>
            </v-flex>

            <!--Quantidade de Vendas-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="qualificar === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Quantidade de vendas no período
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ qualificar }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Valor das Vendas-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="qualificado_com_agendamento === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Valor das vendas no período
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ qualificado_com_agendamento }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'GestaoVendas'
}
</script>

<style scoped>

</style>
